import { render, staticRenderFns } from "./BirdIdTrialEmissionModal.vue?vue&type=template&id=4df255e8&scoped=true&lang=pug"
import script from "./BirdIdTrialEmissionModal.vue?vue&type=script&lang=js"
export * from "./BirdIdTrialEmissionModal.vue?vue&type=script&lang=js"
import style0 from "./BirdIdTrialEmissionModal.vue?vue&type=style&index=0&id=4df255e8&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df255e8",
  null
  
)

export default component.exports